var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Extra Large@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vimeo-icon",
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9880883,5.52430383 C23.881372,8.22871733 22.2489014,11.9338977 19.0935607,16.6364979 C15.8286195,21.546615 13.0655332,24 10.8071861,24 C9.40833762,24 8.22292169,22.5005232 7.25959098,19.5049167 L5.32716112,11.2644884 C4.6061052,8.26553484 3.83601748,6.7694051 3.01401374,6.7694051 C2.83519187,6.7694051 2.20643111,7.20452113 1.13061568,8.08144729 L0,6.3945359 L3.48702642,2.77303168 C5.06469677,1.18987873 6.24722847,0.363158271 7.03462154,0.276135065 C8.90936692,0.071965234 10.0544037,1.5480127 10.484153,4.74778907 L11.4532522,11.1172184 C11.9897178,13.9488196 12.5838679,15.3679673 13.2270498,15.3679673 C13.7289047,15.3679673 14.4816871,14.4508766 15.4882811,12.6233893 C16.4948752,10.7959019 17.0313408,9.39683652 17.1034464,8.43958125 C17.2476576,6.8564283 16.7083077,6.0631783 15.4882811,6.0631783 C14.9114364,6.0631783 14.3230548,6.21044835 13.7144836,6.49829434 C14.868173,2.04672261 17.1582466,-0.118816411 20.4924092,0.00502430584 C22.9670731,0.088700466 24.1322995,1.93961713 23.9880883,5.56112134 L23.9880883,5.52430383 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.cb249cd2fd2d5c8114c9ae55a4663b48.svg";
export { ForwardRef as ReactComponent };